import { useTranslation } from "react-i18next";
import ImageLinks from "../../../assets/Images/ImagesLink";

function CartAreaNotServiceable({ is_pickup_error, is_drop_error }) {
  const { t } = useTranslation();
  const addressType = is_pickup_error && is_drop_error
    ? "pickup_and_delivery"
    : is_pickup_error
      ? "pickup"
      : "delivery";

  return (
    <div
      className="bg-white flex flex-col items-center justify-center fixed bottom-0 px-6 w-full py-[30px]"
      style={{
        boxShadow: `0px -6px 16.7px 0px #F2F2F2`,
      }}
    >
      <img src={ImageLinks.info_circle_black} />
      <p className="font-custom font-bold text-xl mt-3">
        {t("area_not_serviceable")}
      </p>
      <p className="font-custom font-medium text-xs mt-1 text-center">
        {t(`${addressType}_address_not_serviceable`)}
      </p>
      <p className="font-custom font-medium text-xs text-center">
        {t("check_back_or_choose_different_address")}
      </p>
    </div>
  );
}

export default CartAreaNotServiceable;
